import { UserRole } from '@/types';

type UserLike = { role?: UserRole | null } | null | undefined;

export const hasRole = (user: UserLike, roles: UserRole[]): boolean => {
    if (!user || !user.role) {
        return false;
    }

    return roles.includes(user.role);
};
